export const types = {
  SET_ACCOUNT_NUMBER: 'SET_ACCOUNT_NUMBER',
  HYDRATE: 'HYDRATE',
};
